'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'cherries';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e0ec';
var svgPathData = ['M0 336C0 224 96 224 96 224c30.5 0 56.3 9.5 73.4 18.2C183.7 249.4 192 256 192 256s1-.8 2.9-2.2s4.7-3.2 8.4-5.4c7.3-4.4 17.8-9.9 30.8-14.7c15-5.4 33.4-9.7 54-9.7c0 0 96 0 96 112c0 160-144 176-192 176S0 480 0 336zM353.9 488.9c36-32 62.1-80.9 62.1-152.9c0-53.1-18.7-88.3-43.2-110.5c17.1 2.4 32.2 7.4 44.2 12.7c19.4 8.6 31 17.8 31 17.8s7.2-5.7 19.7-12.4c17.1-9 44-19.6 76.3-19.6c0 0 96 0 96 112c0 160-144 176-192 176c-20.3 0-57.6-5.7-94.1-23.1z', 'M302.4 4.8l.3 .2c.3 .2 .8 .6 1.4 1c1.2 .9 2.9 2.2 5 3.9c4.3 3.3 10.3 8.2 17.5 14.5c14.4 12.6 33.7 30.9 53.6 53.9c35.1 40.6 73.3 97.7 87.6 165.3C455.2 250.3 448 256 448 256s-11.6-9.3-31-17.8c-14-50.1-43.6-94.2-73.1-128.5c-14.3-16.6-28.3-30.5-40.1-41.2c-3.1 12.9-7.3 28.2-13 45.1c-11.7 35-29.6 77.5-56.7 120.2c-26 9.4-42 22.3-42 22.3s-8.3-6.6-22.6-13.8c38.4-49.1 61.8-101.8 75.8-143.7c7.7-23 12.4-42.5 15.3-56.3c1.4-6.9 2.4-12.2 2.9-15.8c.3-1.8 .5-3.1 .6-4l.1-.9c.6-5.3 2.9-10.1 6.3-13.8C274.9 2.9 281.1 0 288 0c5.4 0 10.4 1.8 14.4 4.8z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCherries = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;